import { format } from 'date-fns';

export const getHourAndMinutesByDate = (timeGiven) => {
    return format(new Date(timeGiven), 'hh:mm a') + ' ET';
};

export default getHourAndMinutesByDate;
